export default "__VITE_ASSET__d1185612__"